import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationContextBoundComponent } from 'src/app/shared/components';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'account-paused',
  templateUrl: './account-paused.component.html',
  styleUrls: ['./account-paused.component.scss'],
  standalone: false
})
export class AccountPausedComponent extends ApplicationContextBoundComponent implements OnInit {

  pauseReason: string = '';
  userName: string = '';

  constructor(
    private readonly injector: Injector,
    private readonly _router: Router,
    private readonly _localStorageService: LocalStorageService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    const permissions = this.applicationContext?.userPermissions;
    if (permissions) {
      this.pauseReason = permissions.accountPausedReason || 'Your account has been paused by an administrator.';
    }

    const profile = this.applicationContext?.currentlyLoggedInUserProfile?.userProfile;
    if (profile) {
      this.userName = profile.firstName || '';
    }
  }

  onLogoutClicked(): void {
    this._localStorageService.authorizationData = null;
    this._router.navigate(['/login']);
  }

  onProfileClicked(): void {
    const userCompanyGuid = this.applicationContext?.currentlyLoggedInUserProfile?.userProfile?.userCompanyGuid;
    if (userCompanyGuid) {
      this._router.navigate(['/admin/profile', userCompanyGuid]);
    }
  }
}
